import { render } from "./speechText.vue?vue&type=template&id=7d916a39&scoped=true"
import script from "./speechText.vue?vue&type=script&lang=js"
export * from "./speechText.vue?vue&type=script&lang=js"

import "./speechText.vue?vue&type=style&index=0&id=7d916a39&scoped=true&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d916a39"]])

export default __exports__